import { Settings as SettingsIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useRef, useState } from 'react'
import { SavedSearchMenu } from './SavedSearchMenu'

export const SavedSearchMenuButton = () => {
  const [isOpen, setOpen] = useState(false)
  const ref = useRef(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      <Button
        ref={ref}
        title="Settings"
        disableElevation
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        sx={{
          height: 'auto',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >
        <SettingsIcon />
      </Button>
      <SavedSearchMenu
        open={isOpen && !!ref.current}
        onClose={handleClose}
        anchorEl={ref.current}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      />
    </>
  )
}
